// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root .chansey-loader-wrapper {\n    height: 280px;\n    display: flex;\n    width: 100%;\n    justify-content: center;\n    align-items: center;\n    filter: invert(63%) sepia(84%) saturate(3435%) hue-rotate(1deg) brightness(106%) contrast(103%);\n  }\n  .root .button-loader svg circle {\n    fill: var(--primary-bg-text-color);\n  }\n", ""]);
// Exports
module.exports = exports;
